import { Breadcrumb, Spin, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useSCBOneDevice } from "../../api/api.scb-one";
import { SCBOneConfigModalSingle } from "../../components/configuration/SCBOneConfigModalSingle";
import { SCBOneDetails } from "../../components/details/SCBOneDetails";

export function SCBOneDevice() {
  const { t } = useTranslation();
  const history = useHistory();
  const { deviceSerial } = useParams<{
    deviceSerial: string;
  }>();
  const device = useSCBOneDevice(deviceSerial);

  if (!device.value) {
    return (
      <Spin className="centered" aria-label="loading-spinner" size="large" />
    );
  }

  return (
    <SCBOneDetails
      device={device.value}
      breadcrumb={
        <Breadcrumb>
          <Breadcrumb.Item>
            <a
              href="/scb-one"
              onClick={(e) => {
                e.preventDefault();
                history.push("/scb-one");
              }}
            >
              SCB-One
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span style={{ marginRight: "1em" }}>
              {device.value
                ? device.value.serial || device.value.id
                : deviceSerial}
            </span>
            <span style={{ marginRight: "1em" }}>
              {device.value && (
                <SCBOneConfigModalSingle
                  selectedSerial={device.value.serial}
                />
              )}
            </span>
            {!device.value.isEnabled ? (
              <span style={{ marginRight: "1em" }}>
                <Tag color="red" style={{ marginLeft: "1em" }}>
                  {t("beacon:disabled")}
                </Tag>
              </span>
            ) : (
              <span style={{ marginRight: "1em" }}>
                <Tag color="green" style={{ marginLeft: "1em" }}>
                  {t("beacon:enabled")}
                </Tag>
              </span>
            )}
          </Breadcrumb.Item>
        </Breadcrumb>
      }
    />
  );
}
